<modal-header header="Notifications" [dialogRef]="dialogRef" />

<div class="notif-case" mat-dialog-content>
  <div class="row row-cols-lg-1 m-0 gy-2">
    @if (loading()) {
      <loader [loading]="true" />
    } @else {
      @for (group of notificationGroups(); track group.date) {
        <div class="not-group">
          <div class="not-group-header">{{ group.date | date: 'dd MMM yyyy' }}</div>
          <div class="group-by-date d-flex flex-column gap-8">
            @for (titleGroup of group.titleGroup; track titleGroup.title) {
              @let title = titleGroup.title;
              @if (title) {
                <div class="not-header gap-8 d-flex align-items-center">
                  {{ title }}
                  @if (titleGroup.listByTitle.length > 1) {
                    <span class="badge bg-primary">{{ titleGroup.listByTitle.length }}</span>
                  }
                </div>
              }
              @for (item of titleGroup.listByTitle; track item.id) {
                @let expanded = expandedMap()[item.id!];
                <div
                  class="not-item rounded-10 d-flex align-items-center"
                  [ngClass]="{ unread: !item.read }"
                  (mouseenter)="(null)">
                  <div class="status-case">
                    <div class="seen-status"></div>
                  </div>
                  <div
                    class="body-case pointer"
                    (click)="nS.markAsUnread(item); notificationHandlerService.handleNotificationOpen(item)">
                    @let body = item._notification?.body || '';
                    <div class="d-flex align-items-center justify-content-between gap-8">
                      <div
                        class="not-body"
                        [class.expanded]="expanded"
                        [class.w-100]="expanded"
                        #bodyContainer
                        [innerHTML]="body"></div>
                      @if (!expanded) {
                        <div class="notf-time">
                          {{ item.createdOn | date: 'hh:mm a' }}
                        </div>
                      }
                    </div>
                  </div>
                  <div class="action-case" (click)="$event.stopPropagation()">
                    @if (item._notification?.body) {
                      <app-btn
                        [style.visibility]="
                          bodyContainer.scrollWidth <= bodyContainer.clientWidth && !expanded
                            ? 'hidden'
                            : 'visible'
                        "
                        [mini]="true"
                        (mclick)="toggleExpanded(item.id!); nS.markAsUnread(item)"
                        type="clear"
                        customIcon="fa fa-chevron-{{ expanded ? 'up' : 'down' }}" />
                    }
                  </div>
                </div>
              }
            }
          </div>
        </div>
      } @empty {
        <div class="text-center">
          {{ 'There are no notifications' }}
        </div>
      }
      <div class="mt-16 d-flex justify-content-between align-items-center">
        <app-btn text="Notification History" type="clear" (mclick)="historyModal.open()" />
        @if (canLoadMore()) {
          <app-btn
            text="Load More"
            [mini]="true"
            type="primary"
            mclass="px-8"
            (mclick)="loadMore()"
            [loading]="loadingCanLoadMore()" />
        }
      </div>
    }
  </div>
  <modal-comp
    #previewModal
    [header]="selectedNotification()?._notification?.title || 'Notification'"
    [showFooter]="false">
    <ng-template modalBody>
      @if (selectedNotification(); as selectedNotification) {
        <div class="border p-2 rounded-10">
          <div class="" [innerHTML]="selectedNotification._notification?.body"></div>
        </div>
      }
    </ng-template>
  </modal-comp>
</div>
<modal-comp #historyModal header="Notification History" width="1000px" height="auto">
  <ng-template modalBody>
    <notification-history />
  </ng-template>
</modal-comp>
